import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { SessionProvider } from './auth/session';
import './styles.css';
import { applyTheme, storedTheme } from './theme';

/*
 * Before the first paint, not inside a component. Applied during render the page would
 * show the default palette for a frame and then swap — a visible flash on every load for
 * anyone who has chosen dark.
 */
applyTheme(storedTheme());

const container = document.getElementById('root');
if (container === null) throw new Error('No #root element to mount into');

createRoot(container).render(
  <StrictMode>
    <SessionProvider>
      <App />
    </SessionProvider>
  </StrictMode>,
);
